import isEnabled from '../../services/is-experiment-enabled';
export const getExperiments = (state) => state.experiments ?? {};
export const isExperimentEnabled = (state, name, value) => {
    return isEnabled(getExperiments(state), name, value);
};
//# sourceMappingURL=experiments-selectors.js.map